import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconFuelConsumption: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 24 24" name="fuel-consumption">
    <path d="M15.4852 3.5146L15.0609 3.09033L13.1516 4.99988L14.0001 5.84841L15.0492 4.79928C15.8593 5.70484 16.5118 6.74172 16.9778 7.8669C17.4439 8.99211 17.7157 10.1867 17.7832 11.3999H15.3999V12.5999H17.7832C17.7157 13.8131 17.4439 15.0076 16.9778 16.1329C16.5117 17.2581 15.8592 18.295 15.0491 19.2006L13.9999 18.1514L13.1514 18.9999L15.0609 20.9094L15.4852 20.4852C16.5995 19.3709 17.4834 18.048 18.0865 16.5921C18.6895 15.1362 18.9999 13.5757 18.9999 11.9999C18.9999 10.424 18.6895 8.86358 18.0865 7.40768C17.4834 5.95177 16.5995 4.6289 15.4852 3.5146Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8981 12.7782C10.9645 12.53 11 12.2691 11 11.9999C11 10.343 9.65685 8.99988 8 8.99988C6.34315 8.99988 5 10.343 5 11.9999C5 13.6567 6.34315 14.9999 8 14.9999C8.95825 14.9999 9.81156 14.5506 10.3608 13.8512L14.2681 15.8049L14.8048 14.7315L10.8981 12.7782ZM8 13.7999C8.99411 13.7999 9.8 12.994 9.8 11.9999C9.8 11.0058 8.99411 10.1999 8 10.1999C7.00589 10.1999 6.2 11.0058 6.2 11.9999C6.2 12.994 7.00589 13.7999 8 13.7999Z"
    />
  </Icon>
);
